export const CATEGORY_OPTIONS = [
  { value: 'Ópticas y Ortopedias', label: 'Ópticas y Ortopedias' },
  { value: 'Construcción', label: 'Construcción' },
  { value: 'Supermercados', label: 'Supermercados' },
  { value: 'Librerías', label: 'Librerías' },
  { value: 'Alimentos', label: 'Alimentos' },
  { value: 'Farmacias y perfumerías', label: 'Farmacias y perfumerías' },
  { value: 'Vinotecas', label: 'Vinotecas' },
  { value: 'Hogar y deco', label: 'Hogar y deco' },
  { value: 'Veterinarias', label: 'Veterinarias' }
];
